/* Outdoors Nordic. Flyttad ur snippets/on-size-quiz.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */

  (function () {
    if (window.__onSizeQuizBooted) return;
    window.__onSizeQuizBooted = true;

    function boot() {
      /* EN start per sida. Renderas snippeten tva ganger - storleksguideblocket
         OCH variantvaljaren - laser bada boot() samma forsta config, och
         OnSizeQuiz.init binder varje trigger en gang till. Resultatet blir tva
         quizinstanser och ett klick som oppnar quizet tva ganger. */
      if (window.__onSqBooted) return;
      /* Renderas quizet fran BADE variantvaljaren och storleksguideblocket
         finns tva configar pa sidan, och querySelector tar den forsta - vilket
         beror pa blockens ordning i mallen, inte pa vad som ar ratt. Det nya
         laget vinner nar det finns: det ar den design kunden faktiskt ser. */
      var noder = document.querySelectorAll('[data-on-sq-config]');
      var node = null;
      for (var i = 0; i < noder.length; i++) {
        if (!node) node = noder[i];
        try {
          if (JSON.parse(noder[i].textContent).mode === 'two') { node = noder[i]; break; }
        } catch (e) {}
      }
      if (!node || !window.OnSizeQuiz) return;
      /* Trasig config ska inte doda quizet TYST. Utan den har ser kunden
         knappen men ingenting hander, och ingenting syns i konsolen heller -
         det varsta felet att felsoka. Katalogen genomsokt 2026-10-09: 18
         produkter, noll trasiga. Skyddet ar for framtiden, inte for i dag. */
      var cfg;
      try {
        cfg = JSON.parse(node.textContent);
      } catch (err) {
        console.warn('[on-size-quiz] configen gick inte att lasa, quizet startar inte:', err);
        return;
      }

      // slang nycklar Shopify inte kunde oversatta sa JS-standardtexten vinner
      Object.keys(cfg.strings || {}).forEach(function (k) {
        var v = cfg.strings[k];
        if (typeof v !== 'string' || v.indexOf('translation missing') === 0) delete cfg.strings[k];
      });

      if (cfg.sizeSet && cfg.sizeSet.sizes && cfg.sizeSet.sizes.length) {
        window.__onSqBooted = true;
        window.OnSizeQuiz.init(cfg);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    // Pratbubblan: visas forst nar kunden skrollat ner till knappen, sa den
    // syns dar blicken redan ar. Stangs den, eller oppnar kunden quizet, ar
    // den borta resten av besoket (sessionStorage, inte localStorage - nasta
    // besok ar ett nytt kopbeslut och da far den visas igen).
    (function bubble() {
      var NYCKEL = 'onSqBubbleDold';
      var el = document.querySelector('[data-on-sq-bubble]');
      var trigger = document.querySelector('[data-on-sq-trigger]');
      if (!el || !trigger) return;

      var dold = false;
      try { dold = sessionStorage.getItem(NYCKEL) === '1'; } catch (e) {}
      if (dold) { el.remove(); return; }

      // Bubblan flyttas UT ur produktkolumnen till <body>. Ligger den kvar dar
      // knappen star hamnar den under produktpunkterna, och det enda satt att
      // lyfta den (z-index pa foraldern) drog samtidigt upp sjalva knappen over
      // den fasta headern. Som fixed-element i body finns ingen sadan konflikt,
      // och den kan alltid hallas innanfor skarmkanten.
      document.body.appendChild(el);

      var aktiverad = false;

      // Placerar bubblan strax ovanfor knappen, i DOKUMENTETS koordinater, sa
      // den ligger still och foljer sidan vid scroll utan att JS kor om. Den
      // halls alltid innanfor skarmens bredd, och pilen foljer knappens
      // mittpunkt aven nar bubblan skjutits i sidled.
      function placera() {
        var tr = trigger.getBoundingClientRect();
        if (!tr.width) return false;

        var br = el.getBoundingClientRect();
        var bredd = br.width || 300;
        var hojd = br.height || 44;
        var MARG = 12;

        var mitt = tr.left + tr.width / 2;
        var vanster = mitt - bredd / 2;
        var maxVanster = window.innerWidth - bredd - MARG;
        if (maxVanster < MARG) maxVanster = MARG;
        if (vanster < MARG) vanster = MARG;
        else if (vanster > maxVanster) vanster = maxVanster;

        // Fixed = skarmkoordinater, alltsa direkt ur getBoundingClientRect.
        el.style.left = Math.round(vanster) + 'px';
        el.style.top = Math.round(tr.top - hojd - 12) + 'px';

        var pil = mitt - vanster;
        if (pil < 14) pil = 14;
        if (pil > bredd - 14) pil = bredd - 14;
        el.style.setProperty('--on-sq-pil', Math.round(pil) + 'px');
        return true;
      }

      function gomBubblan() {
        if (!el || !el.parentNode) return;
        aktiverad = false;
        el.classList.remove('is-in');
        try { sessionStorage.setItem(NYCKEL, '1'); } catch (e) {}
        setTimeout(function () { if (el && el.parentNode) el.remove(); }, 240);
      }

      function aktivera() {
        if (aktiverad || !el.parentNode) return;
        aktiverad = true;
        // Bada utlosarna kopplas bort - harifran ror vi inte bubblan mer.
        try { if (io) io.disconnect(); } catch (e) {}
        window.removeEventListener('scroll', kollaOmIVyn);
        placera();
        // Ett andra varv efter att typsnittet satt sig, annars kan hojden ha
        // andrats och bubblan hamna nagra pixlar fel.
        requestAnimationFrame(function () { placera(); el.classList.add('is-in'); });
      }

      // Visa nar knappen skrollats in i vyn. Tva oberoende utlosare, for annars
      // uteblir bubblan: vid snabb scroll (fling pa mobil) kan knappen passera
      // hela vyn mellan tva renderade frames, och da triggar observern aldrig.
      // Scroll-kontrollen fangar det. Bada kopplas bort sa fort en av dem
      // aktiverat, och ingen av dem flyttar bubblan - den ligger still.
      function kollaOmIVyn() {
        if (aktiverad) return;
        var tr = trigger.getBoundingClientRect();
        if (tr.bottom > 0 && tr.top < window.innerHeight) aktivera();
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (poster) {
          for (var i = 0; i < poster.length; i++) {
            if (poster[i].isIntersecting) { setTimeout(aktivera, 150); return; }
          }
        }, { threshold: 0 });
        io.observe(trigger);
      }
      window.addEventListener('scroll', kollaOmIVyn, { passive: true });
      kollaOmIVyn();

      // Bubblan foljer knappen. Forsoket att placera den EN gang och lata den
      // ligga still gick inte att lita pa: sidan fortsatter vaxa efter
      // placeringen (lazy-bilder, karuseller, appar) och knappen glider nedat -
      // uppmatt 373 px fel. Att folja ar det enda som alltid hamnar ratt.
      //
      // requestAnimationFrame gor att vi flyttar den hogst en gang per bildruta
      // i stallet for pa varje scroll-event, vilket var det som hackade forut.
      var vantar = false;
      function foljKnappen() {
        if (!aktiverad || !el.parentNode || vantar) return;
        vantar = true;
        requestAnimationFrame(function () {
          vantar = false;
          placera();
        });
      }

      window.addEventListener('scroll', foljKnappen, { passive: true });
      window.addEventListener('resize', foljKnappen, { passive: true });
      window.addEventListener('load', foljKnappen);

      var x = el.querySelector('[data-on-sq-bubble-close]');
      if (x) x.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); gomBubblan(); });
      trigger.addEventListener('click', gomBubblan);
    })();

    // Forvaljer den rekommenderade storleken i produktformularet nar det finns.
    document.addEventListener('on:size-quiz:result', function (e) {
      var size = e.detail && e.detail.size;
      if (!size) return;
      var form = document.querySelector('product-form-component, form[action*="/cart/add"]');
      if (!form) return;

      var input = form.querySelector('input[type="radio"][value="' + CSS.escape(size) + '"]');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var selects = form.querySelectorAll('select');
      Array.prototype.forEach.call(selects, function (s) {
        var match = Array.prototype.filter.call(s.options, function (o) { return o.value === size; })[0];
        if (match) {
          s.value = size;
          s.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  })();
